import { ActionType, getType } from 'typesafe-actions';

import { tetrisGlobalActions } from './tetrisGlobal.actions';
import { TetrisGlobalState } from './tetrisGlobal.types';

export const INITIAL_STATE: TetrisGlobalState = {
  help: {
    showHelpModal: false
  },
  video: {
    playVideo: '',
    miniPlayer: false
  }
};

export function globalState(
  state: TetrisGlobalState = INITIAL_STATE,
  action: ActionType<typeof tetrisGlobalActions>
): TetrisGlobalState {
  switch (action.type) {
    case getType(tetrisGlobalActions.showHelpModal):
      return {
        ...state,
        help: {
          ...state.help,
          showHelpModal: action.payload,
        },
      };
    case getType(tetrisGlobalActions.playVideo):
      return {
        ...state,
        video: {
          ...state.video,
          playVideo: action.payload
        }
      };
    case getType(tetrisGlobalActions.miniPlayer):
      return {
        ...state,
        video: {
          ...state.video,
          miniPlayer: action.payload
        }
      };
  }

  return state;
}
